(function() {
    'use strict';

    angular
        .module('ceo', ['ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ui.router',
            'ngMaterial',
            'toastr',
            'angularMoment',
            'ui.select2',
            'odecui',
            'datePicker',
            'ui.odometer'
        ]);

})();
(function() {
  'use strict';

  angular
      .module('ceo')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Ruby)',
        'url': 'http://sass-lang.com/',
        'description': 'Original Syntactically Awesome StyleSheets implemented in Ruby',
        'logo': 'ruby-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

;(function() {
    'use strict';

    angular.module('odecui', []);
}());
;(function() {
    'use strict';

        /**
            * @ngdoc directive
            * @name odecui.directive:odecuiSelect2
            * @restrict A
            * 
            * @description Es una directiva que genera un componente de dependiente de select2.js. 
            * Basicamente genera un componente select que tiene buscador. El funcionamiento del 
            * plugin select2 esta en http://ivaynberg.github.io/select2/
            * 
            * @element div
            *
            * @param {object} datos datos para el combo, con el formato que espera {id:,text:}
            * @param {string} selection elemento seleccionado, es el id del elemento que esta en datos
            * @param {object} options opciones extra que se pueden pasar al plugin (p.ej. width,placeholder)
            * @param {string} events nombre del evento que se emite. el evento que se emite tiene el formato selectionChanged:%events%
            * 
            * @example 
            * <input type='hidden' 
            *     name='{{combo.name}}' id='{{combo.name}}' class="seleccion form-control" 
            *     odecui-select2 
            *     datos="combo.datos" 
            *     selection="combo.selectedNode" 
            *     options="{width:'100%',allowClear: true,placeholder:'...'}" 
            *     events="{{filtro.id}}"/>
            *
            * js
            *
            * $scope.combo.datos = [{id:'item1',text:'elemento 1'},{id:'item2',text:'elemento 2'}..]
            * $scope.combo.selectedNode = 'item1'
            * $scope.filtro.id = "combo1"
            *     
        **/
        
    angular.module('odecui')
    .directive('odecuiSelect2', [function() {

            return {
                restrict: 'A',
                scope: {
                    datos: '=',
                    selection: '=',
                    options: '=',
                    notRemovable: '@',
                    events: '@',
                    select2Disabled: '='
                },
                link: function postLink(scope, iElement, iAttrs) {

                    scope.selection = scope.selection || null;
                    scope.datos = scope.datos || [];

                    var nombre = iAttrs.name;
                    var newSelection = {};


                    var opciones = {
                        data: angular.fromJson(scope.datos)
                    };

                    if (!angular.isUndefined(scope.options)) {
                        angular.extend(opciones, scope.options);
                    }

                    if (angular.isUndefined(opciones.placeholder)) {
                        opciones.placeholder = 'Selecciona ' + nombre;
                    }


                    $(iElement).val(scope.selection);

                    if (!angular.isUndefined(scope.notRemovable)) {
                        if (scope.notRemovable === 'true') {
                            opciones.allowClear = false;
                        }
                    }

                    /**
                     * Aqui es donde se inicializa
                     */
                    $(iElement).select2(opciones);

                    /**
                     * Vamos a emitir un evento al hacer una seleccion. Para
                     * poder discriminar cual es el combo que lo ha hecho añadimos
                     * esta propiedad extra que nos permitira generar eventos diferentes
                     * en funcion del combo
                     *
                     * @type {String}
                     */
                    var eventos = '';

                    if (angular.isUndefined(scope.events)) {
                        eventos = 'selectionChanged';
                    } else {
                        eventos = 'selectionChanged:' + scope.events;
                    }

                    /**
                     * Aqui emitimos el evento y cambiamos el elemento seleccionado
                     *
                     * @param  {object} e
                     */
                    $(iElement).on('change', function(e) {
                        var newSelection = {};
                        newSelection[nombre] = $(iElement).val();
                        scope.$apply(function() {
                            scope.selection = $(iElement).val();
                        });
                        scope.$emit(eventos, newSelection);
                    });

                    /**
                     * comprobamos el cambio de los datos del combo para repintarlo
                     */
                    scope.$watch('datos', function() {
                        newSelection = {};

                        opciones = {
                            data: angular.fromJson(scope.datos)
                        };

                        if (!angular.isUndefined(scope.options)) {
                            angular.extend(opciones, scope.options);
                        }

                        if (angular.isUndefined(opciones.placeholder)) {
                            opciones.placeholder = 'Select ' + nombre;
                        }

                        opciones.readonly = true;

                        $(iElement).val(scope.selection);


                        if (!angular.isUndefined(scope.notRemovable)) {
                            if (scope.notRemovable === 'true') {
                                opciones.allowClear = false;
                            }
                        }

                        var disabled;
                        if (!angular.isUndefined(scope.select2Disabled)) {
                            disabled = scope.select2Disabled;
                        }


                        $(iElement).select2(opciones);
                        
                        if (opciones.data.length === 1 && scope.selection) {
                            $(iElement).select2('enable', false);
                        } else {
                            $(iElement).select2('enable', true);
                        }

                        if (disabled) {
                            $(iElement).select2('enable', false);
                        }

                    });

                    /**
                     * revisamos el cambio de la seleccion
                     */
                    scope.$watch('selection', function() {
                        $(iElement).select2('val', scope.selection);
                    });

                    scope.$watch('select2Disabled', function(newvalue) {
                        if (newvalue) {
                            $(iElement).select2('enable', false);
                        } else {
                            $(iElement).select2('enable', true);
                        }
                    });


                }
            };
        }
    ]);
}());
;(function() {
    'use strict';

    angular.module('odecui')
        .directive('odecuiProgressBar', [

            function() {

                return {
                    restrict: 'E',
                    scope: {
                        curVal: '@',
                        maxVal: '@'
                    },
                    template: "<div class='odecui-progress-bar'>" +
                        "<div class='odecui-progress-bar-bar'></div>" +
                        "</div>",

                    link: function($scope, element, attrs) {

                        function updateProgress() {
                            var progress = 0;

                            if ($scope.maxVal) {
                                progress = Math.min($scope.curVal, $scope.maxVal) / $scope.maxVal * element.find('.odecui-progress-bar').width();
                            }

                            element.find('.odecui-progress-bar-bar').css('width', progress);
                        }

                        $scope.$watch('curVal', updateProgress);
                        $scope.$watch('maxVal', updateProgress);
                    }
                };
            }
        ]);
})();
/*global Odometer:true*/
;(function() {
    'use strict';

    angular.module('odecui')
        .directive('odecuiOdometer', [

            function() {
                return {
                    restrict: 'A',
                    scope: {
                        //valor que se quiere usar
                        endValue: '=value'
                    },
                    link: function(scope, element) {
                        var od = new Odometer({
                            el: element[0],
                            value: 0, // default value
                            format: 'ddd.d'
                        });

                        scope.$watch('endValue', function() {
                            od.update(parseFloat(scope.endValue*10).toFixed(1));                            
                            console.log('Odometer: ' + scope.endValue);
                        });
                    }
                };
            }
        ]);
}());

(function() {
  'use strict';

  angular
    .module('ceo')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('ceo')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

;(function () {
    'use strict';

    angular.module('odecui')
    .service('loadingService', [function(){
        this.loader = {};
        this.loader.loading = false;
    }]);
}());
/*global Highcharts:true*/
/* @flow */
;(function() {
    'use strict';

    angular.module('odecui')

        /**
            * @ngdoc service
            * @name odecui.odecuiHighchartsSrv
            *
            * @description Este servicio viene a ser una libreria de configuraciones de 
            * graficos reusables para highcharts
        **/
        .service('odecuiHighchartsSrv', [function() {
                this.gauge = {
                    chart: {
                        renderTo: '',
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        plotBorderWidth: 0,
                        plotShadow: false,
                        height: 200,
                        backgroundColor: null
                    },

                    title: {
                        text: null
                    },

                    pane: {
                        startAngle: -150,
                        endAngle: 150,
                        background: [{
                            backgroundColor: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#FFF'],
                                    [1, '#333']
                                ]
                            },
                            borderWidth: 0,
                            outerRadius: '109%'
                        }, {
                            backgroundColor: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#333'],
                                    [1, '#FFF']
                                ]
                            },
                            borderWidth: 1,
                            outerRadius: '107%'
                        }, {
                            // default background
                        }, {
                            backgroundColor: '#DDD',
                            borderWidth: 0,
                            outerRadius: '105%',
                            innerRadius: '103%'
                        }]
                    },

                    // the value axis
                    yAxis: {
                        min: -4,
                        max: 12,

                        minorTickInterval: 'auto',
                        minorTickWidth: 1,
                        minorTickLength: 10,
                        minorTickPosition: 'inside',
                        minorTickColor: '#666',

                        tickPixelInterval: 30,
                        tickWidth: 2,
                        tickPosition: 'inside',
                        tickLength: 10,
                        tickColor: '#666',
                        labels: {
                            step: 2,
                            rotation: 'auto'
                        },
                        title: {
                            text: null
                        },
                        plotBands: [{
                            from: 11,
                            to: 12,
                            color: '#55BF3B' // green
                        }, {
                            from: 9,
                            to: 11,
                            color: '#DDDF0D' // yellow
                        }, {
                            from: -4,
                            to: 9,
                            color: '#DF5353' // red
                        }]
                    },
                    credits: {
                        enabled: false
                    },
                    series: null
                };

                this.bars = {
                    chart: {
                        renderTo: '',
                        type: 'bar',
                            backgroundColor: null,
                            height: 200,
                            marginTop: 15
                    },
                    colors: ['#424F63'],
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    subtitle: {
                        text: null
                    },
                    xAxis: {
                        categories: null,

                        title: {
                            text: null
                        },
                        labels: {
                            enabled: true
                        },
                        lineWidth: 0,
                        minorGridLineWidth: 0,
                        lineColor: 'transparent',
                        minorTickLength: 0,
                        tickLength: 0
                    },
                    yAxis: {
                        min: -100,
                        max:100,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        lineWidth: 0,
                        minorGridLineWidth: 0,
                        lineColor: 'transparent',
                        minorTickLength: 0,
                        tickLength: 0,
                        gridLineColor: 'transparent'
                    },
                    tooltip: {
                        formatter: function() {
                            return '<b>' + this.x + '</b>:' + this.y;
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                align: 'right',
                                color: '#FFFFFF',
                                x: -10
                            }
                            /*pointPadding: 0,
                  groupPadding: 0,
                  borderWidth: 0, 
                  shadow: false*/
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    series: null
                };

                this.donut = {
                    colors: ['#17548A', '#1E6BAE', '#FAB700', '#EF434F', '#C7111E', '#C7111E'],
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: 0,
                        plotShadow: false,
                        height: 200
                    },
                    title: {
                        text: null,
                        verticalAlign: 'middle'
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                    },
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false,
                                distance: 1
                            },
                            showInLegend: false
                        }
                    },
                    credits: {
                        enabled: false
                    },

                    series: []
                };

                this.solidgauge = {
                    chart: {
                        type: 'solidgauge',
                        height: 200
                    },

                    title: {
                        text: ''
                    },

                    pane: {

                        startAngle: -90,
                        endAngle: 90,
                        background: {
                            backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || '#EEE',
                            innerRadius: '60%',
                            outerRadius: '100%',
                            shape: 'arc'
                        }
                    },

                    tooltip: {
                        enabled: false
                    },

                    // the value axis
                    yAxis: {
                        minColor: '#C7111E',
                        maxColor: '#25CF0B',
                        min: 0,
                        max: 200,                        
                        lineWidth: 0,
                        minorTickInterval: null,
                        tickPixelInterval: 400,
                        tickWidth: 0,
                        title: {
                            text: '',
                            y: -70
                        },
                        labels: {
                            y: 16
                        }
                    },

                    credits: {
                        enabled: false
                    },

                    plotOptions: {
                        solidgauge: {
                            dataLabels: {
                                y: -30,
                                borderWidth: 0,
                                useHTML: true,
                                style: {
                                    fontSize: '1.25em'
                                }
                            }
                        }
                    },
                    series: []
                };

                this.line = {
                    chart: {
                        renderTo: '',
                        height: 300,
                        /*margin: 0*/
                    },
                    title: {
                        text: null
                    },
                    xAxis: {
                        categories: [],
                        labels: {
                            maxStaggerLines: 1,
                            rotation: 20
                        }
                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        lineWidth: 0,
                        minorGridLineWidth: 0,
                        lineColor: 'transparent',
                        minorTickLength: 0,
                        tickLength: 0,
                        gridLineColor: 'transparent'
                    },
                    tooltip: {
                        shared: true,
                        crosshairs: true,
                        formatter: function() {
                            var s = '<b>' + this.x + '</b>';

                            $.each(this.points, function(i, point) {
                                s += '<br/>' + point.series.name + ': ' +
                                    Highcharts.numberFormat(point.y, 1);
                            });

                            return s;
                        },
                    },

                    plotOptions: {
                        series: {
                            cursor: 'pointer',                            
                            marker: {
                                fillColor: '#FFFFFF',
                                lineWidth: 2,
                                lineColor: null,
                                states: {
                                    hover: {
                                        fillColor: 'white',
                                        radius: 7
                                    }
                                }
                            }
                        }
                    },
                    credits: {
                        enabled: false
                    },

                    series: []
                };
            }
        ])
        
            /**
                * @ngdoc directive
                * @name odecui.directive:highchart
                * @restrict A
                * 
                * @description Directiva con dependencias en la libreria de charts highcharts. Se ha 
                * parametrizado algunas ideas para poder hacer un componente que genere facilmente 
                * graficos.
                *
                * @param {object} config Objeto de configuracion de un chart de highcharts
                * @param {object} datos Serie para highcharts
                * @param {string} titulo Titulo del chart
                * @param {function} despues funcion que se ejecutara una vez creado el grafico
                * @param {array} categorias Array de strings que nos daran las etiquetas de las categorias
                * @param {string} gaugetitulo Es el titulo en caso de que el chart sea un gauge ya que va en un sitio diferente
                * @param {object} solidgaugemaxmin Es un objeto que tiene dos elementos max y min y son los valores maximo y minimo de un gauge
                * @param {string} objective Es el objetivo en un grafico de barras
                * @param {Number} objectivey Es el objetivo en el eje Y (independiente del tipo de gráfico.)
                * @param {String} objectiveyTextEs el texto que se mostrara en el Objectivoy.
                * @param {boolean} setSeriesPointClick Nos dice si se genera un evento en el click de una serie. Esto haria un emit como odecuiHigcharts:seriesClick con los parametros del punto sobre el que se ha hecho click
                * 
                * 
                * @element div
                * @example 
            **/        
        .directive('highchart', ['$timeout','$rootScope', function($timeout, $rootScope) {
                return {
                    restrict: 'A',
                    priority:1005,
                    scope: {
                        config: '=',
                        datos: '@',
                        titulo: '@',
                        despues: '&',
                        categorias: '=',
                        gaugetitulo: '@',
                        solidgaugemaxmin: '=',
                        objective: '=',
                        objectivey: '=',
                        objectiveyText: '=',
                        setSeriesPointClick: '='
                    },
                    link: function postLink(scope, iElement, iAttrs) {
                        console.log('link:highcharts');
                        var opciones,chart;

                        

                        function inicializacion() {
                            opciones = angular.copy(scope.config);
                            chart = {};

                            /**
                             * Puede ser que no se le pasen datos porque se le pase en la config con lo que 
                             * los datos ya estarian en opciones.series. El orden seria: 1) datos en el atributo
                             * datos 2) Datos en config 3) Array en blanco
                             * @type {[type]}
                             */                           
                            opciones.series = angular.fromJson(scope.datos) || opciones.series || [];

                            if (scope.categorias && scope.categorias.length > 0) {
                                opciones.xAxis.categories = scope.categorias;
                            }

                            /**
                             * Elemento donde se va a renderizar. Lo cogemos del DOM. Es importante en el HTML
                             * a cada grafico ponerle un id diferente
                             * @type {[type]}
                             */
                            opciones.chart.renderTo = $(iElement).attr('id');                            


                            if (scope.gaugetitulo) {
                                opciones.yAxis.title.text = scope.gaugetitulo;
                            }

                            if (!angular.isUndefined(scope.solidgaugemaxmin)) {
                                opciones.yAxis.max = scope.solidgaugemaxmin.max;
                                opciones.yAxis.min = scope.solidgaugemaxmin.min;
                                opciones.yAxis.tickPositions = [opciones.yAxis.min, opciones.yAxis.max];
                            }

                            if (scope.setSeriesPointClick) {
                                opciones.plotOptions = opciones.plotOptions || {};
                                opciones.plotOptions.series = opciones.plotOptions.series || {};
                                opciones.plotOptions.series.point = opciones.plotOptions.series.point || {};
                                opciones.plotOptions.series.point.events = {
                                    click: function(event) {
                                        scope.$emit('odecuiHigcharts:seriesClick',{'event':event,'item':this});
                                    }
                                };

                            }


                            /**
                             * Lanzamiento del highcharts, si se le pasa un metodo al scope de la directiva
                             * entonces se ejecutara despues de generar el chart
                             */
                            if (scope.$eval(scope.despues)) {
                                chart = new Highcharts.Chart(opciones, scope.despues);                                
                            } else {
                                chart = new Highcharts.Chart(opciones);
                            }
                            $rootScope.$emit('highcharts:ready', chart); 

                            $timeout(function(){ chart.reflow(); },300);

                            // experimental. ponemos un paramtro extra en las series para que si hay un atributo
                            // que sea disable que oculte la serie
                            // 
                            (function disableSeries() {
                                var disabled = _.pluck(_.filter(opciones.series,{disable:true}),'name');

                                if (disabled.length > 0 ) {
                                    _.each(chart.series,function(item) {
                                        if (disabled.indexOf(item.name) !== -1) { 
                                            item.hide();
                                        }
                                    });                                    
                                }
                            })();

                            /**
                             * En el caso de querer poner un objetivo a una column chart se le pasa el valor
                             */
                            if (angular.isDefined(scope.objective)) {
                                chart.yAxis[0].addPlotLine({
                                    value: scope.objective,
                                    color: '#C80E0E',
                                    width: 2,
                                    zIndex: 4,
                                    label: {
                                        text: 'National Av. ' + scope.objective,
                                        rotation: 0,
                                        textAlign: 'left',
                                        y: -3,
                                        x: -70

                                    }

                                });
                            }

                            /**
                             * En el caso de querer poner un objetivo en el eje Y
                             */
                            if (angular.isDefined(scope.objectivey)) {
                                chart.xAxis[0].addPlotLine({
                                    value: scope.objectivey,
                                    color: '#C80E0E',
                                    width: 2,
                                    zIndex: 4,
                                    label: {
                                        text: scope.objectiveyText || ' '
                                    }
                                });
                            }

                            /**
                             * Esto es un problema que no he podido solucionar de ningun otro modo
                             * @type {[type]}
                             */
                            if (opciones.chart.type === 'gauge') {
                                $(iElement).find('.highcharts-data-labels').attr('visibility', 'visible');
                            }
                        }                        

                        //inicializacion();

                        scope.$watch('datos', function(datos) {
                            console.log('link:highcharts::Watch');
                            inicializacion();
                        });

                        scope.$watch('config', function(config) {
                            console.log('link:highcharts::Watch:Config');
                            inicializacion();
                        });
                    }
                };
            }
        ]);
}());
(function() {
  'use strict';

  angular
    .module('ceo')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

;(function() {
    'use strict';

    angular.module('ceo')

    .factory('focus', function($timeout, $window) {
        return function(id) {
            // timeout makes sure that is invoked after any other event has been triggered.
            // e.g. click events that need to run before the focus or
            // inputs elements that are in a disabled state but are enabled when those events
            // are triggered.
            $timeout(function() {
                var element = $window.document.getElementById(id);
                if (element)
                    element.focus();
            });
        };
    })

    .directive('eventFocus', function(focus) {
        return function(scope, elem, attr) {
            elem.on(attr.eventFocus, function() {
                focus(attr.eventFocusId);
            });

            // Removes bound events in the element itself
            // when the scope is destroyed
            scope.$on('$destroy', function() {
                element.off(attr.eventFocus);
            });
        };
    });
})();
;(function() {
    'use strict';

    angular.module('ceo')

    .factory('focus', function($timeout, $window) {
        return function(id) {
            // timeout makes sure that is invoked after any other event has been triggered.
            // e.g. click events that need to run before the focus or
            // inputs elements that are in a disabled state but are enabled when those events
            // are triggered.
            $timeout(function() {
                var element = $window.document.getElementById(id);
                if (element)
                    element.focus();
            });
        };
    })

    .directive('eventFocus', function(focus) {
        return function(scope, elem, attr) {
            elem.on(attr.eventFocus, function() {
                focus(attr.eventFocusId);
            });

            // Removes bound events in the element itself
            // when the scope is destroyed
            scope.$on('$destroy', function() {
                element.off(attr.eventFocus);
            });
        };
    });
})();
/* global localStorage:true */
;(function () {
	'use strict';

	angular.module('ceo')
		.service('storageService', ['$cookies',function ($cookies) {

			// save property
			this.save = function save(property,data){
				if (localStorage){
					localStorage.setItem(property,angular.toJson(data));
				}else {
					$cookieStore.put(property,angular.toJson(data));
				}
				// $cookieStore.put(property,angular.toJson(data));
			};

			// retrieve property
			this.retrieve = function retrieve(property) {
				if (localStorage){
					return angular.fromJson(localStorage.getItem(property));
				}else {
					return angular.fromJson($cookieStore.get(property));
				}
				// return angular.fromJson($cookieStore.get(property));
			};

			// remove property
			this.remove  = function remove(property) {
				if (localStorage){
					localStorage.removeItem(property);
				}else {
					$cookieStore.remove(property);
				}
				// $cookieStore.remove(property);
			};
			
		}]);

}());
;(function() {
    'use strict';

    function navigationService($timeout, $log, $http, $q) {
        var indice;
        var path;
        var lastStep;
        var currentStep;


        function getIndice() {
            var deferred = $q.defer();
            if (indice) {
                return $q.when(indice);
            } else {
                $http.get('../../datos/indice.json')
                    .success(function(data) {
                        indice = [{
                            id: '-1',
                            text: 'Baròmetre',
                            sections: data
                        }];
                        deferred.resolve(indice);
                    })
                    .error(function(data, status) {
                        $log.log('Error on [ navigationService ] - [ ' + data + ' ]. Status [ ' + status + ' ]');
                        deferred.reject(status);
                    });

                return deferred.promise;
            }
        }

        function getStepIndex(step) {
            return vm.path.indexOf(step);
        }

        function getStepsOnPath() {
            return path.length;
        }

        function getNextStep(step) {
            var nstep = getStepIndex(step);
            if (nstep < getStepsOnPath() - 1) {
                return vm.path[nstep + 1];
            } else {
                return undefined;
            }
        }

        function getStep(index) {
            return path[index];
        }

        function getPreviousStep(step) {
            var index = getStepIndex(step);
            if (index > 0) {
                return getStep(index);
            } else {
                return undefined;
            }
        }

        function openCloseStepWays(step) {
            if (step.hasOwnProperty('showWays')) {
                step.showWays = !step.showWays;
            } else {
                step.showWays = true;
            }
        }

        function addStepToPath(step) {}

        function isStepOnPath(step) {
            return vm.path.indexOf(step) !== -1;
        }

        function pushStep(step) {
            openCloseStepWays(currentStep);
            openCloseStepWays(step);
            addStepToPath(step);
            if (isStepOnPath(step)) {
                vm.path.push(step);
            }
        }

        var navigation = {
            getIndice: getIndice
        };

        return navigation;
    }

    angular.module('ceo')
        .factory('navigationService', navigationService);

    navigationService.$inject = ['$timeout', '$log', '$http', '$q'];
})();
;
(function() {
    'use strict';

    function mainService($timeout, $log, $http, $q) {
        var indice;

        function getIndice() {
            var deferred = $q.defer();
            if (indice) {
                return $q.when(indice);
            } else {
                $http.get('./datos/indice.json')
                    .success(function(data) {
                        indice = [{
                            id: 'ROOT',
                            text: 'Blocs del qüestionari',
                            sections: data
                        }];
                        deferred.resolve(indice);
                    })
                    .error(function(data, status) {
                        $log.log('Error on [ mainService ] - [ ' + data + ' ]. Status [ ' + status + ' ]');
                        deferred.reject(status);
                    });

                return deferred.promise;
            }
        }

        function getEntry(section, parentId) {
            var id;
            if (parentId) {
                if (_.startsWith(section.id, parentId)) {
                    id = section.id;
                } else if (parentId !== 'ROOT' && !_.startsWith(section.id, 'T')) {
                    id = parentId + section.id;
                } else {
                    id = section.id;
                }
            } else {
                id = section.id;
            }
            return {
                id: id,
                text: section.text,
                group: section.group,
                parent: parentId
            };
        }

        function getPathToEntry(entryId) {
            var path = getIndiceList();
            var steps = [];
            var currentStep = _.find(path, 'id', entryId);
            while (currentStep.parent) {
                steps.push(currentStep);
                currentStep = _.find(path, 'id', currentStep.parent);
            }
            steps.push(currentStep);
            steps = _(steps).reverse().value();
            var entries = [];
            var group = indice;
            _.forEach(steps, function(step) {
                currentStep = _.find(group, 'id', step.id);
                if (currentStep) {
                    group = currentStep.sections;
                    entries.push(currentStep);
                }
            });
            return entries;
        }

        function getEntries(section, parentId) {
            var entries = [];
            entries.push(getEntry(section, parentId));
            entries = entries.concat(_.map(section.items, function(item) {
                return getEntry(item, section.id);
            }));
            _.forEach(section.sections, function(s) {
                entries = entries.concat(getEntries(s, section.id));
            });
            return entries;
        }

        function getIndiceList() {
            var list = [];
            _.forEach(indice, function(e) {
                list = list.concat(getEntries(e));
            });
            return list;
        }

        var aspects = {
            getIndice: getIndice,
            getIndiceList: getIndiceList,
            getPathToEntry: getPathToEntry
        };

        return aspects;
    }

    angular.module('ceo')
        .factory('mainService', mainService);

    mainService.$inject = ['$timeout', '$log', '$http', '$q'];
})();
(function() {
    'use strict';

    angular
        .module('ceo')
        .controller('MainController', MainController);

    MainController.$inject = ['$timeout', 'indice', 'indiceList', 'toastr', 'navigationService', '$state', 'storageService', 'path', 'focus', 'mainService', 'loadingService'];

    /** @ngInject */
    function MainController($timeout, indice, indiceList, toastr, nSrv, $state, sSrv, path, focus, mSrv, loadingSrv) {
        var vm = this;
        vm.indice = _.clone(indice);
        var lastStep;
        vm.search = {
            text: undefined,
            items: undefined
        };
        if (!path) {
            vm.path = [vm.indice[0]];
            vm.currentStep = vm.path[0];
            vm.showPathPanel = true;
        } else {
            vm.path = path;
            vm.currentStep = vm.path[vm.path.length - 1];
            if (vm.path.length > 1) {
                lastStep = vm.path[vm.path.length - 2];
            }
            vm.showPathPanel = false;
        }

        vm.loader = loadingSrv.loader;

        vm.onSearchKeyUp = function($event) {
            if ($event.keyCode === 13) {
                if (vm.search.items.length === 1) {
                    vm.onPathClick(vm.search.items[0]);
                }
            } else if ($event.keyCode === 27) {
                vm.search.text = undefined;
                vm.search.items = undefined;
                vm.showSearchPanel = false;
            }
        };

        vm.doSearch = function() {
            var searchList = indiceList;
            if (!vm.search.text) {
                vm.search.items = undefined;
            } else {
                if (vm.search.text.length === 0) {
                    vm.search.items = undefined;
                } else {
                    vm.search.items = _.filter(searchList, function(i) {
                        if (i.text) {
                            return i.text.toUpperCase().indexOf(vm.search.text.toUpperCase()) > -1 && i.group === 'items';
                        } else {
                            return false;
                        }
                    });
                }
            }
        };

        vm.onSearchPanelButtonClick = function() {
            vm.search.text = undefined;
            vm.search.items = undefined;
            vm.showSearchPanel = !vm.showSearchPanel;
            if (vm.showSearchPanel) {
                vm.showPathPanel = false;
            }
        };

        function getNextStep(step) {
            var nstep = vm.path.indexOf(step);
            if (nstep < vm.path.length - 1) {
                return vm.path[nstep + 1];
            } else {
                return undefined;
            }
        }

        function openCloseStepWays(step) {
            if (step.items || step.sections) {
                if (step === vm.currentStep) {
                    vm.showPathPanel = !vm.showPathPanel;
                } else {
                    vm.showPathPanel = true;
                }
            } else {
                vm.showPathPanel = false;
            }
        }

        function addStepToPath(step) {}

        function isStepOnPath(step) {
            return vm.path.indexOf(step) !== -1;
        }

        function openCatalog(catalog) {
            sSrv.save('path', vm.path);
            sSrv.save('currentStep', vm.currentStep);
            sSrv.save('lastStep', lastStep);
            sSrv.save('lastTimestampTag', new Date());
            $state.go('main.evolution', {
                catalog: catalog
            });
        }

        vm.onPathClick = function(step) {
            if (step.id.length > 8) {
                vm.showSearchPanel = false;
                vm.path = mSrv.getPathToEntry(step.id);
                vm.currentStep = step;
                lastStep = _.takeRight(vm.path, 1);
                openCatalog(step.id);
            } else {
                if (step != vm.currentStep) {
                    openCloseStepWays(vm.currentStep);
                }
                openCloseStepWays(step);
                if (!isStepOnPath(step)) {
                    var nCurrentStep = vm.path.indexOf(vm.currentStep);
                    if (nCurrentStep >= 0) {
                        vm.path = _.take(vm.path, nCurrentStep + 1);
                    }
                    if (step.group !== 'items') {
                        vm.path.push(step);
                    }
                }
                lastStep = vm.currentStep;
                vm.currentStep = step;
                if (vm.currentStep.group === 'items') {
                    var catalog = lastStep.id + vm.currentStep.id;
                    openCatalog(catalog);
                }
            }
        };

        /* 02/12/2015
        vm.onPathClick = function(step) {
            if (step != vm.currentStep) {
                openCloseStepWays(vm.currentStep);
            }
            openCloseStepWays(step);
            addStepToPath(step);
            if (!isStepOnPath(step)) {
                var nCurrentStep = vm.path.indexOf(vm.currentStep);
                if (nCurrentStep >= 0) {
                    vm.path = _.take(vm.path, nCurrentStep + 1);
                }
                vm.path.push(step);
            }
            lastStep = vm.currentStep;
            vm.currentStep = step;
            if (vm.currentStep.group === 'items') {
                var catalog = lastStep.id + vm.currentStep.id;
                sSrv.save('path', vm.path);
                sSrv.save('currentStep', vm.currentStep);
                sSrv.save('lastStep', vm.lastStep);
                $state.go('main.evolution', {
                    catalog: catalog
                });
            }
        };
        */

        /*
        vm.onPathClick = function(step) {
            if (_.indexOf(vm.path, step) === -1) {
                lastStep =.currentStep;
               .currentStep = step;
                vm.path.push(step);
                if (lastStep) {
                    lastStep.showWays = false;
                }
                if (step.hasOwnProperty('showWays')) {
                    step.showWays = !step.showWays;
                } else {
                    step.showWays = true;
                }
            } else {
                var nextStep = getNextStep(currentStep);
                if (nextStep !== step && vm.path.indexOf(step) < vm.path.length) {
                    var path = _.take(vm.path, vm.path.indexOf(currentStep));
                    vm.path = path;
                }
                lastStep =.currentStep;
               .currentStep = step;
                if (_.indexOf(vm.path, step) === -1) {
                    vm.path.push(step);
                }
                if (lastStep) {
                    lastStep.showWays = false;
                }
                if (step.hasOwnProperty('showWays')) {
                    step.showWays = !step.showWays;
                } else {
                    step.showWays = true;
                }
            }
        };
        */

        vm.onClick = function(option) {
            if (option.group === 'items') {
                /// presentamos el gráfico de la pregunta.
            } else {
                vm.indice = [];
                if (option.hasOwnProperty('sections')) {
                    vm.indice = vm.indice.concat(option.sections);
                }
                if (option.hasOwnProperty('items')) {
                    vm.indice = vm.indice.concat(option.items);
                }
            }
        };
    }
})();

;
(function() {
    'use strict';

    function filtroService($rootScope, $log, $q, vSrv) {
        var _compare = {
            source: null,
            target: null
        };
        var _period = {
            from: new Date(),
            to: new Date()
        };

        var breakdown = null;

        function setComparisonSource(id) {
            if (angular.isDefined(id)) {
                _compare.source = id;
            }
        }

        function setComparison(source, target) {
            setComparisonSource(source);
            setComparisonTarget(target);
        }

        function setComparisonTarget(id) {
            if (angular.isDefined(id)) {
                _compare.target = id;
            }
        }

        function isComparing() {
            if (angular.isDefined(_compare.source)) {
                if (angular.isDefined(_compare.target)) {
                    if (_compare.source === null || _compare.target === null)
                        return false;
                    else
                        return true;
                } else
                    return false;
            } else {
                return false;
            }
        }

        function setBreakdown(item) {
            if (angular.isDefined(item) && item !== null) {
                breakdown = _.extend(item, {});
            } else
                breakdown = null;
        }

        function getFilter() {
            var filter = {
                source: _compare.source,
                target: _compare.target,
                breakdown: breakdown,
                period: _period
            };
            return filter;
        }

        function hasBreakdowns() {
            if (angular.isDefined(breakdown))
                return breakdown !== null;
            return false;
        }

        function getComparison() {
            var deferred = $q.defer();
            vSrv.getVenues().then(function(lvenues) {
                if (lvenues.length > 0)
                    _compare.source = lvenues[0].id;
                deferred.resolve({
                    source: _compare.source,
                    target: _compare.target
                });
            }, function(err) {
                $log.log(err);
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getPeriod() {
            return _.extend({}, _period);
        }

        function setPeriod(from, to) {
            _period.from = from;
            _period.to = to;
        }

        var filtro = {
            getPeriod: getPeriod,
            setPeriod: setPeriod,
            hasBreakdowns: hasBreakdowns,
            setComparison: setComparison,
            getComparison: getComparison,
            isComparing: isComparing,
            setBreakdown: setBreakdown,
            getFilter: getFilter
        };

        return filtro;
    }

    angular.module('ceo')
    /**
     * Este servicio se encargara del manejo de los filtros. Es un adhoc en su estructura ya que cada web puede tener unos
     * filtros diferentes.
     */
    .factory('filtroService', filtroService);

    filtroService.$inject = ['$rootScope', '$log', '$q', 'venuesService'];
})();
;
(function() {
    'use strict';

    function filtroController($rootScope, fSrv, vSrv, lVenues, lBreakdowns) {
        var vm = this;
        var comparison = null;
        var breakdown = null;

        initialize(vm);

        function initialize(model) {
            model.breakdowns = lBreakdowns;
            model.open = false;
            vm.breakdowns = lBreakdowns;
            vm.vbdselected = vm.breakdowns[0].id;
            model.period_aux = null;
            vm.dtCollapsedFrom = true;
            vm.dtCollapsedTo = true;
            vm.period = null;
            vm.venues = lVenues;
            loadFilterFromService(fSrv);

            vm.comparison = comparison;
            vm.vs = {
                id: comparison.source,
                text: vSrv.getVenueText(comparison.source)
            };
            vm.vt = {
                id: comparison.target,
                text: vSrv.getVenueText(comparison.target)
            };
            vm.isComparing = fSrv.isComparing;
            vm.textBreakdowns = getTextBreakdown(breakdown);
            vm.minDate = new Date('01/01/2014');
            vm.maxDate = new Date('12/31/2020');
        }

        function loadFilterFromService(srv) {
            var filter = srv.getFilter();
            breakdown = filter.breakdown;
            vm.period_aux = filter.period;
            vm.period = _.extend({}, vm.period_aux);
            comparison = {
                source: filter.source ? filter.source : lVenues[0].id,
                target: filter.target
            };
        }

        vm.clearPeriod = function() {
            vm.period_aux = {
                from: null,
                to: null
            };
        };

        vm.ChangeCollapsedStateFrom = function() {
            vm.dtCollapsedFrom = !vm.dtCollapsedFrom;
            if (!vm.dtCollapsedFrom && vm.dtCollapsedTo === false) {
                vm.dtCollapsedTo = true;
            }
        };

        vm.ChangeCollapsedStateTo = function() {
            vm.dtCollapsedTo = !vm.dtCollapsedTo;
            if (!vm.dtCollapsedTo && vm.dtCollapsedFrom === false) {
                vm.dtCollapsedFrom = true;
            }
        };

        vm.fromDateChanged = function() {
            vm.period_aux.from = moment(vm.period_aux.from).format('L');
            vm.dtCollapsedFrom = true;
        };

        vm.toDateChanged = function() {
            vm.period_aux.to = moment(vm.period_aux.to).format('L');
            vm.dtCollapsedTo = true;
        };

        function getCompareItems(comparison) {
            var ci = [];
            var ssource = 'Total';
            var starget = 'Total';
            var item;
            if (angular.isDefined(comparison)) {
                if (angular.isDefined(comparison.source)) {
                    item = _.find(vm.venues, {
                        id: comparison.source
                    });
                    if (angular.isDefined(item))
                        ssource = item.text;
                }
                if (angular.isDefined(comparison.target)) {
                    item = _.find(vm.venues, {
                        id: comparison.target
                    });
                    if (angular.isDefined(item))
                        starget = item.text;
                }
            }
            ci.push(ssource);
            if (starget != 'Total')
                ci.push(starget);
            return ci;
        }

        function getTextBreakdown(item) {
            if (angular.isUndefined(item) || item === null)
                return 'None';

            var vbd = null;
            var cbd = null;
            vbd = _.find(vm.breakdowns, {
                id: item.varid
            });
            if (angular.isDefined(vbd)) {
                cbd = _.find(vbd.options, {
                    id: item.catid
                });
                if (angular.isDefined(cbd)) {
                    return vbd.text + ' - ' + cbd.text;
                } else {
                    return 'None';
                }
            } else {
                return 'None';
            }
        }

        function getTextPeriod(period) {
            if (angular.isUndefined(period))
                return 'None';
            if (period === null)
                return 'None';
            if (period.from === null || period.to === null)
                return 'None';
            var from = new moment(period.from).format('L');
            var to = new moment(period.to).format('L');
            return from + ' - ' + to;
        }

        vm.periodText = getTextPeriod(vm.period);

        /**
         * Funcion que se llama cuando se hace click en el boton de aplicar filtro, se emite un evento filtro.aplicar
         */
        function applyFilter() {
            vm.open = false;
            if (vm.comparison.source === null || vm.comparison.source === "")
                vm.comparison.source = "0";
            if (vm.comparison.target === "")
                vm.comparison.target = null;
            fSrv.setComparison(vm.comparison.source, vm.comparison.target);
            if (angular.isDefined(breakdown)) {
                if (breakdown !== null) {
                    if (breakdown.varid !== null && breakdown.catid !== null)
                        fSrv.setBreakdown((breakdown));
                } else {
                    fSrv.setBreakdown(null);
                }
            } else {
                fSrv.setBreakdown(null);
            }
            fSrv.getComparison().then(function(comparison) {
                vm.vs = {
                    id: comparison.source,
                    text: vSrv.getVenueText(comparison.source)
                };
                vm.vt = {
                    id: comparison.target,
                    text: vSrv.getVenueText(comparison.target)
                };
                vm.isComparing = fSrv.isComparing;
                if (breakdown !== null)
                    vm.textBreakdowns = getTextBreakdown(breakdown);
                else
                    vm.textBreakdowns = 'None';
                vm.period.from = vm.period_aux.from;
                vm.period.to = vm.period_aux.to;
                fSrv.setPeriod(vm.period.from, vm.period.to);
                vm.periodText = getTextPeriod(vm.period);
                $rootScope.$emit('filtro.aplicar');

            }, function(err) {
                $log.log(err);
            });
        }

        $rootScope.$on('selectionChanged', function(event, args) {
            if (angular.isDefined(args.Q3) || angular.isDefined(args.Q4) || angular.isDefined(args.Q5) || angular.isDefined(args.Q6) || angular.isDefined(args.Q7)) {
                setPropertiesToNull(vm.breakdown);
                for (var property in args) {
                    vm.breakdown[property] = args[property];
                    if (vm.breakdown[property] === null || vm.breakdown[property] === '')
                        breakdown = null;
                    else
                        breakdown = {
                            varid: property,
                            catid: args[property]
                        };
                }
            }
        });

        function setPropertiesToNull(item) {
            for (var property in item) {
                item[property] = null;
            }
        }

        function BDSelected(id) {
            setPropertiesToNull(vm.breakdown);
        }

        vm.BDSelected = BDSelected;

        vm.aplicar = applyFilter;

        vm.changeDate = function(modelName, newDate) {
            console.log(modelName + ' has had a date change. New value is ' + newDate.format());
            $scope.callbackState = 'Callback: Fired';
        };

    }

    angular.module('ceo')
        .controller('filtroController', filtroController);

    filtroController.$inject = ['$rootScope', 'filtroService', 'venuesService', 'lVenues', 'lBreakdowns'];
})();
;
(function() {
    'use strict';

    function EvolutionService($timeout, $log, $http, $q, colorService) {
        function getEmptyCategories(categories, data) {
            var aEmpty = _.map(categories, function(cat, ncat) {
                return data[ncat] === 0 || data[ncat] === null;
            });
            return aEmpty;
        }

        function getEmptyCategoriesFromSeries(categories, data) {
            var aEmpty = _.map(categories, function(cat, ncat) {
                var isEmpty = _.reduce(data.series, function(result, serie) {
                    return result && (serie.data[ncat] === null);
                }, true);
                return isEmpty;
            });
            return aEmpty;
        }

        function cleanData(categories, data, summaries) {
            var aEmpty = getEmptyCategories(categories, summaries);

            /*
            var aEmpty = summaries ? getEmptyCategories(categories, summaries) : getEmptyCategoriesFromSeries(categories, data);
            */

            var firstIndex = aEmpty.indexOf(false);
            data.series = _.map(data.series, function(serie) {
                return {
                    name: serie.name,
                    data: _.takeRight(serie.data, aEmpty.length - firstIndex)
                };
            });
            return {
                categories: _.takeRight(categories, aEmpty.length - firstIndex),
                data: data
            };
        }

        function prepareSeries(series, category) {
            var color;
            series = _.map(series, function(s) {
                color = colorService.getColorFromName(s.name);
                if (color) {
                    s.color = color.color;
                }
                if (category === 'scale') {
                    s.visible = false;
                    if (s.name.toUpperCase() === 'MITJANA') {
                        s.visible = true;
                        s.dashStyle = 'ShortDashDot';
                        s.lineWidth = 4;
                        s.marker = {
                            enabled: true,
                            radius: 5,
                            lineWidth: 1
                        };
                    }
                }
                if (s.name.toUpperCase() === ('PxC. Plataforma per Catalunya').toUpperCase() || s.name.toUpperCase() === ('UPyD').toUpperCase() || (s.name).toUpperCase() === ('Barcelona en comú').toUpperCase() || s.name.toUpperCase() === ('Reagrupament.cat').toUpperCase() || s.name.toUpperCase() === ('CDC').toUpperCase()) {
                    s.visible = false;
                }
                return s;
            });
            return series;
        }

        function getChart(cross, data, summaries, category) {
            var cleanedData = cleanData(cross.categories, data, summaries, category);
            cross.categories = cleanedData.categories;
            data = cleanedData.data;
            data.series = prepareSeries(data.series, category);
            return {
                chart: {
                    marginTop: 93,
                    spacingLeft: 25,
                    spacingRight: 25,
                    // plotBackgroundColor: '#EEE',
                    plotBorderWidth: 0,
                    plotShadow: false,
                    type: 'spline',
                    zoomType: 'x'
                },
                title: {
                    text: data.title,
                    style: {
                        fontSize: '14px',
                        fontFamily: 'Arial'
                    },
                    y: 30
                },
                credits: {
                    enabled: true,
                    href: 'http://ceo.gencat.cat',
                    text: 'Centre d\'Estudis d\'Opinió',
                    style: {
                        fontSize: '12px'
                    }
                },
                exporting: {
                    enabled: false
                },
                subtitle: {
                    text: data.subtitle,
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Arial'
                    },
                    y: 75
                },
                xAxis: {
                    categories: cross.categories
                },
                yAxis: {
                    title: null
                },
                tooltip: {
                    crosshairs: true,
                    shared: false,
                    valueDecimals: 1,
                    // pointFormat: '{series.name}: <b>{point.y}</b><br/>',
                    formatter: function() {
                        if (this.series.name.toUpperCase() !== 'MITJANA') {
                            return this.series.name + ': ' + '<b>' + this.point.y + '%</b><br/>';
                        } else {
                            return this.series.name + ': ' + '<b>' + this.point.y + '</b><br/>';
                        }
                    }
                },
                plotOptions: {
                    spline: {
                        marker: {
                            enabled: true,
                            radius: 3,
                            lineWidth: 1
                        }
                    }
                },
                series: data.series
            };
        }

        function getItemsViewModel(items) {
            return _.map(items, function(item, nItem) {
                return {
                    id: (item.id) ? item.id : nItem,
                    text: item.text
                };
            });
        }

        function createFilterViewModel(catalogFilters) {
            return {
                variables: _.map(catalogFilters, function(item) {
                    return {
                        id: item.id,
                        text: item.text
                    };
                }),
                items: [],
                selection: {
                    variable: catalogFilters[0].id,
                    item: undefined
                }
            };
        }

        function getOrderedSeriesItems(sources) {
            var series = getOrderedSerieTitlesByAverage(sources);
            var options = _.map(series, function(s) {
                return {
                    name: s.name,
                    visible: true
                };
            });
            return options;
        }

        function getOrderedSerieTitlesByAverage(source) {
            var ordered = [];
            var m = _.findIndex(source, function(s) {
                return s.name.toUpperCase() === 'MITJANA';
            });
            _.forEach(source, function(s, nSerie) {
                if (nSerie === m) {
                    ordered = [s].concat(ordered);
                } else {
                    ordered.push(s);
                }
            });
            return getSeriesItems(ordered);
        }

        function getSeriesItems(source) {
            return _.map(source, function(s) {
                return {
                    name: s.name,
                    visible: true
                };
            });
        }

        function hasEnoughtSample(summaries) {
            var sample = _.reduce(summaries, function(total, summary) {
                return total + parseFloat(summary);
            }, 0);
            return sample > 20 * _.compact(summaries).length;
        }

        var evolution = {
            getChart: getChart,
            createFilterViewModel: createFilterViewModel,
            getItemsViewModel: getItemsViewModel,
            getEmptyCategories: getEmptyCategories,
            getOrderedSerieTitlesByAverage: getOrderedSerieTitlesByAverage,
            getOrderedSeriesItems: getOrderedSeriesItems,
            hasEnoughtSample: hasEnoughtSample,
            getSeriesItems: getSeriesItems,
            getEmptyCategoriesFromSeries: getEmptyCategoriesFromSeries
        };

        return evolution;
    }

    angular.module('ceo')
        .factory('EvolutionService', EvolutionService);

    EvolutionService.$inject = ['$timeout', '$log', '$http', '$q', 'colorService'];
})();
(function() {
    'use strict';

    /** @ngInject */
    function EvolutionController($scope, $timeout, indice, toastr, eSrv, cSrv, filters, $rootScope, currentSelection, sSrv, catalog, $mdToast, loadingService, $mdMenu) {
        var vm = this;
        var catalogFilters = filters;
        vm.filter = eSrv.createFilterViewModel(filters);
        vm.showItems = vm.filter.items.length > 0;
        vm.export = {
            isOpen: false
        };
        var chart;
        vm.catalog = catalog;
        vm.series = [];
        vm.allSeries = true;

        vm.showFilter = true;
        vm.loadingService = loadingService;

        if (currentSelection) {
            vm.filter.selection.variable = currentSelection.variable;
            onVariableChanged(currentSelection.variable);
            vm.filter.selection.item = currentSelection.item;
            onItemChanged(currentSelection.item);
        } else {
            updateChart(vm.filter.selection.variable, vm.filter.items[0] ? vm.filter.items[0].id : '001');
        }

        function updateChart(vId, iId) {
            var reference = vId + iId;
            var chartData = cSrv.getCurrentCatalogDataSeries(reference);
            var v = _.find(catalogFilters, 'id', vId);
            chartData.data.subtitle = v.text.toUpperCase();
            if (vm.filter.selection.item) {
                var item = _.find(v.items, 'id', iId);
                if (item) {
                    var iText = item.text;
                    if (iText) {
                        chartData.data.subtitle = chartData.data.subtitle + iText;
                    }
                }
                chartData.data.subtitle = chartData.data.subtitle.toUpperCase();
            }

            var aEmpty = eSrv.getEmptyCategories(chartData.cross.categories, chartData.wavesSummaries);

            /*
            var aEmpty = chartData.wavesSummaries ? eSrv.getEmptyCategories(chartData.cross.categories, chartData.wavesSummaries) : eSrv.getEmptyCategoriesFromSeries(chartData.cross.categories, chartData.data);
            */

            /*
            var aEmpty = eSrv.getEmptyCategories(chartData.cross.categories, chartData.data);
            */
            var nOlas = aEmpty.length - _.compact(aEmpty).length;
            vm.showChart = iId === '800' ? true : eSrv.hasEnoughtSample(chartData.wavesSummaries);
            if (nOlas > 3) {} else if (nOlas > 0 && nOlas <= 3) {
                if (vm.showChart) {
                    $mdToast.show({
                        position: 'top right',
                        template: '<md-toast class="toast-error">Hi ha poques onades per a mostrar en el gràfic evolutiu</md-toast>',
                        theme: 'error-toast'
                    });
                }
            } else {
                vm.showChart = false;
            }
            if (vm.showChart) {
                vm.chart = eSrv.getChart(chartData.cross, chartData.data, chartData.wavesSummaries, chartData.category);
                if (vm.filter.selection != currentSelection) {
                    sSrv.save('currentSelection', vm.filter.selection);
                }
            }
            if (chartData.category === 'scale') {
                vm.series = eSrv.getOrderedSeriesItems(chartData.data.series);
            } else {
                vm.series = eSrv.getSeriesItems(chartData.data.series);
            }
        }

        function onVariableChanged(vId) {
            if (vId) {
                var items = _.find(catalogFilters, 'id', vId).items;
                vm.filter.items = eSrv.getItemsViewModel(items);
                if (vId === catalogFilters[0].id) {
                    vm.showItems = false;
                    updateChart(vm.filter.selection.variable, vm.filter.items[0] ? vm.filter.items[0].id : '001');
                } else {
                    if (vm.filter.items.length > 0) {
                        vm.showItems = true;
                    } else {
                        updateChart(vm.filter.selection.variable + vm.filter.items[0].id);
                        vm.showItems = false;
                    }
                }
            } else {
                vm.showItems = false;
            }
            vm.filter.selection.item = undefined;
        }

        function onItemChanged(iId) {
            if (iId) {
                updateChart(vm.filter.selection.variable, iId);
            }
        }

        vm.onChartExport = function(format) {
            var exportConfig = {
                filename: catalog,
                scale: 1
            };
            switch (format) {
                case 'PDF':
                    {
                        exportConfig.type = 'application/pdf';
                        break;
                    }
                case 'PNG':
                    {
                        exportConfig.type = 'image/png';
                        break;
                    }
                case 'JPEG':
                    {
                        exportConfig.type = 'image/jpeg';
                        break;
                    }
            }
            chart.exportChart(exportConfig);
        };

        var originatorEv;
        vm.openOptionsMenu = function($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        };

        var originatorOptionsEv;
        vm.openExportMenu = function($mdOpenMenu, ev) {
            originatorOptionsEv = ev;
            $mdOpenMenu(ev);
        };

        vm.onChartPrint = function() {
            // $mdMenu.hide();
            $timeout(function() {
                chart.print();
            }, 300);
        };

        function changeAllSeriesState(state) {
            var chartCloned = _.clone(vm.chart, true);
            _.forEach(chartCloned.series, function(s) {
                s.visible = state;
            });
            _.forEach(vm.series, function(s) {
                s.visible = state;
            });
            vm.chart = chartCloned;
        }

        vm.showAllSeries = function() {
            changeAllSeriesState(true);
            vm.allSeries = true;
        };

        vm.showNoneSeries = function() {
            changeAllSeriesState(false);
            vm.allSeries = false;
        };

        vm.changeSerieState = function(serie) {
            serie.visible = !serie.visible;
            var chartCloned = _.clone(vm.chart, true);
            var clonedSerie = _.find(chartCloned.series, 'name', serie.name);
            if (clonedSerie) {
                clonedSerie.visible = serie.visible;
                vm.chart = chartCloned;
            }
        };

        var onVariableChangeListener = $rootScope.$on('selectionChanged:onVariableChanged', function(event, args) {
            var vId = args.variableFilter;
            onVariableChanged(vId);
            $scope.$apply();
        });

        var onCategoryChangeListener = $rootScope.$on('selectionChanged:onCategoryChanged', function(event, args) {
            var iId = args.itemFilter;
            onItemChanged(iId);
            $scope.$apply();
        });

        function onHighchartsReady(event, args) {
            chart = args;
        }

        var onHighchartsReadyListener = $rootScope.$on('highcharts:ready', onHighchartsReady);

        $scope.$on('$destroy', function() {
            onVariableChangeListener();
            onCategoryChangeListener();
            onHighchartsReadyListener();
        });
    }

    angular
        .module('ceo')
        .controller('EvolutionController', EvolutionController);

    EvolutionController.$inject = ['$scope', '$timeout', 'indice', 'toastr', 'EvolutionService', 'CatalogService', 'filters', '$rootScope', 'currentSelection', 'storageService', 'catalog', '$mdToast', 'loadingService', '$mdMenu'];

})();
;
(function() {
    'use strict';

    function colorService($timeout, $log, $http, $q) {
        var aColors;

        function getColors() {
            var deferred = $q.defer();
            $http.get('./datos/colores.json')
                .success(function(data) {
                    if (!aColors) {
                        aColors = data;
                    }
                    deferred.resolve(aColors);
                })
                .error(function(data, status) {
                    $log.log('Error on [ colorService ] - [ ' + data + ' ]. Status [ ' + status + ' ]');
                    deferred.reject(status);
                });

            return deferred.promise;
        }

        function getColorFromName(name) {
            return _.find(aColors, function(item) {
                return item.name.toUpperCase() === name.toUpperCase();
            });
        }

        var colors = {
            getColors: getColors,
            getColorFromName: getColorFromName
        };

        return colors;
    }

    angular.module('ceo')
        .factory('colorService', colorService);

    colorService.$inject = ['$timeout', '$log', '$http', '$q'];
})();
;
(function() {
    'use strict';

    function CatalogService($timeout, $log, $http, $q) {
        var currentCatalog;
        var scaleDesc = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

        function getFiltersFromTable(t) {
            var filter = _.find(t.titles, 'type', 'FT').text;
            return filter.split(':');
        }

        function getVariablesFromTables(tables) {
            var variables = [];
            _.each(tables, function(t) {
                var parts = getFiltersFromTable(t);
                var v = _.find(variables, 'id', parts[0].substr(0, 3));
                if (v) {
                    v.items.push({
                        id: parts[0].substr(3, 3),
                        text: parts[2]
                    });
                } else {
                    variables.push({
                        id: parts[0].substr(0, 3),
                        text: parts[1],
                        items: [{
                            id: parts[0].substr(3, 3),
                            text: parts[2]
                        }]
                    });
                }
            });
            return variables;
        }

        function createCatalog(data) {
            return {
                filters: getVariablesFromTables(data),
                tables: data
            };
        }

        function getTablesWithVariable(tables, vId) {
            var fTables = _.filter(tables, function(t) {
                var parts = getFiltersFromTable(t);
                return _.startsWith(parts[0], vId);
            });
            return fTables;
        }

        function hasEnoughtSample(table) {
            var startRow = _.findIndex(table.rows, 'type', 'variable');
            startRow += _.findIndex(table.rows[startRow].items, 'type', 'summary');
            var startCol = _.findIndex(table.columns, 'type', 'variable');
            var samples = _.takeRight(table.data[startRow], table.columns[startCol].items.length);
            var sampleWithData = _.filter(samples, function(sample) {
                return sample[0] !== '0';
            });
            var total = _.sum(samples, function(sample) {
                return sample[0];
            });
            var totalWithData = 20 * sampleWithData.length;
            return total > totalWithData;
        }

        function populateAverageData(vTable, tables, tData) {
            vTable.data = [];
            var start, nAverage, nTable;
            nTable = 0;
            _.forEach(vTable.rows[0].items, function(i, nItem) {
                if (nItem <= 1) {
                    if (nItem === 0) {
                        start = _.findIndex(tables[nTable].columns, 'type', 'variable');
                        vTable.data.push(_.map(tables[nTable].data[1], function(d) {
                            return [0];
                        }));
                    } else {
                        vTable.data.push(tData);
                    }
                } else {
                    start = _.findIndex(tables[nTable].rows, 'type', 'variable');
                    nAverage = _.findIndex(tables[nTable].rows[start].items, function(i) {
                        return (i.type === 'categoria' && i.text === 'Mitjana');
                    });
                    _.forEach(tables[nTable].data[start], function(base, nBase) {
                        if (vTable.data[0][nBase][0] === 0 || vTable.data[0][nBase][0] === null) {
                            vTable.data[0][nBase] = [parseFloat(base[0])];
                        } else {
                            vTable.data[0][nBase] = [parseFloat(vTable.data[0][nBase]) + parseFloat(base[0])];
                        }
                    });
                    if (hasEnoughtSample(tables[nTable])) {
                        vTable.data.push(tables[nTable].data[start + nAverage]);
                    } else {
                        i.delete = true;
                    }
                    nTable++;
                }
            });
            _.remove(vTable.rows[0].items, function(i) {
                return i.delete;
            });
        }

        function createVirtualTable(cFT, template, items) {
            var vTable = {};
            vTable = _.clone(template, true);
            var ft = _.find(vTable.titles, 'type', 'FT');
            if (ft) {
                ft.text = cFT;
            }
            var v = _.find(vTable.rows, 'type', 'variable');
            vTable.rows = [v];
            v.items = _.map(items, function(i, nItem) {
                return {
                    type: 'categoria',
                    text: i.text.trim()
                };
            });
            v.items = [{
                type: 'summary',
                text: 'Total Mostra real'
            }].concat(v.items);
            return vTable;
        }

        function createAverageTable(v, template, tables, items, tData) {
            var desc = v.id + '800:Mitjana';
            items = [{
                id: '000',
                text: 'Total'
            }].concat(items);
            var vTable = createVirtualTable(desc, template, items);
            populateAverageData(vTable, tables, tData);
            return vTable;
        }

        function createTotalTable(v, template, tables, items) {
            var desc = v.id + '900:Total';
            var vTable = createVirtualTable(desc, template, items);
            populateTotalData(vTable, tables);
            return vTable;
        }

        function createVirtualCatalog(data) {
            var variables = [];
            var vTables = [];
            _.each(data, function(t) {
                var parts = getFiltersFromTable(t);
                var v = _.find(variables, 'id', parts[0].substr(0, 3));
                if (v) {
                    v.items.push({
                        id: parts[0].substr(3, 3),
                        text: parts[2]
                    });
                } else {
                    v = {
                        id: parts[0].substr(0, 3),
                        text: parts[1],
                        items: []
                    };
                    if (parts.length === 3) {
                        v.items.push({
                            id: '800',
                            text: 'Mitjana'
                        });
                        var tables = getTablesWithVariable(data, v.id);
                        var items = getVariablesFromTables(tables)[0].items;
                        var template = tables[0];

                        var tTotal = getTablesWithVariable(data, 'F01')[0];
                        var tVariable = _.find(tTotal.rows, 'type', 'variable');
                        var tdIndex = _.findIndex(tVariable.items, function(i) {
                            return (i.type === 'categoria' && i.text === 'Mitjana');
                        });
                        var tData = tTotal.data[_.findIndex(tTotal.rows, tVariable) + tdIndex];
                        var vTable = createAverageTable(v, template, tables, items, tData);
                        vTables.push(vTable);

                        /*
                        vTable = createTotalTable(v, template, tables, items);
                        vTables.push(vTable);
                        */
                    }
                    v.items.push({
                        id: parts[0].substr(3, 3),
                        text: parts[2]
                    });
                    variables.push(v);
                }
            });
            return {
                filters: variables,
                tables: data.concat(vTables)
            };
        }

        function openCatalog(catalog) {
            var deferred = $q.defer();
            $http.get('./datos/' + catalog + '.json')
                .success(function(data) {
                    var nPregunta = catalog.substr(catalog.length - 4);
                    nPregunta = parseInt(nPregunta);
                    if (nPregunta >= 8000 || (nPregunta >= 2000 && nPregunta < 3000)) {
                        currentCatalog = createVirtualCatalog(data);
                    } else {
                        currentCatalog = createCatalog(data);
                    }
                    deferred.resolve(currentCatalog.filters);
                })
                .error(function(data, status) {
                    $log.log('Error on [ CatalogService ] - [ ' + data + ' ]. Status [ ' + status + ' ]');
                    deferred.reject(status);
                });

            return deferred.promise;
        }

        function getCurrentCatalogFilters() {
            return currentCatalog.filters;
        }

        function getCategoryItemText(category) {
            return category.text.substr(category.text.indexOf(':') + 1);
        }

        function getxAxisFromDataTable(table) {
            var xVariable = _.find(table.columns, 'type', 'variable');
            return {
                title: xVariable.text.substr(_.indexOf(xVariable.text, '#') + 1),
                categories: _.map(xVariable.items, getCategoryItemText)
            };
        }

        function getCategoryDataSerie(item) {

        }

        function getNumericValue(source) {
            var value = parseFloat(source);
            if (!isNaN(value)) {
                value = parseFloat(value);
                value = value.toFixed(2);
                return parseFloat(value);
            } else {
                return null;
            }
        }

        function getSeriesDataTable(table) {
            var xVariable = _.find(table.rows, 'type', 'variable');
            var start = table.rows.indexOf(xVariable);
            var startCol = table.columns.indexOf(_.find(table.columns, 'type', 'variable'));
            var series;
            if (xVariable) {
                series = {
                    title: xVariable.text.substr(_.indexOf(xVariable.text, '#') + 1),
                    series: []
                };
                _.forEach(xVariable.items, function(item, nItem) {
                    if (item.type === 'categoria') {
                        series.series.push({
                            name: item.text,
                            data: _.map(_.takeRight(table.data[start + nItem], table.data[start + nItem].length - startCol), function(values, ncol) {
                                return getNumericValue(values[0]);
                            })
                        });
                    }
                });
                return series;
            } else {
                return undefined;
            }
        }

        function getDataTableByReference(reference) {
            return _.find(currentCatalog.tables, function(t) {
                var filter = _.find(t.titles, 'type', 'FT');
                if (filter) {
                    return _.startsWith(filter.text, reference + ':');
                } else {
                    return false;
                }
            });
        }

        function getWavesSummaries(table) {
            var v = _.find(table.rows, 'type', 'variable');
            var colStart = _.findIndex(table.rows, 'type', 'variable');
            var sIdx = _.findIndex(v.items, 'type', 'summary');
            if (sIdx > -1) {
                var data = _.takeRight(table.data[colStart + sIdx], table.data[colStart + sIdx].length - 1);
                var summaries = _.map(data, function(values) {
                    return getNumericValue(values[0]);
                });
                return summaries;
            } else {
                return undefined;
            }
        }

        function isScaleDesc(series) {
            var result = true;
            if (series.length > scaleDesc.length) {
                for (var nSerie = 0; nSerie < scaleDesc.length; nSerie++) {
                    if (series[nSerie + 1] !== scaleDesc[nSerie]) {
                        result = false;
                        break;
                    }
                }
                return result;
            } else {
                return false;
            }
        }

        function categorizeDataSeries(series) {
            var names = _.map(series, 'name');
            if (isScaleDesc(names)) {
                return 'scale';
            } else {
                return 'other';
            }
        }

        function getCurrentCatalogDataSeries(reference) {
            var table = getDataTableByReference(reference);
            var xAxis = getxAxisFromDataTable(table);
            var series = getSeriesDataTable(table);
            var category = categorizeDataSeries(series.series);
            var wsm = getWavesSummaries(table);
            return {
                cross: xAxis,
                data: series,
                category: category,
                wavesSummaries: wsm
            };
        }

        var catalog = {
            openCatalog: openCatalog,
            getCurrentCatalogFilters: getCurrentCatalogFilters,
            getCurrentCatalogDataSeries: getCurrentCatalogDataSeries
        };

        return catalog;
    }

    angular.module('ceo')
        .factory('CatalogService', CatalogService);

    CatalogService.$inject = ['$timeout', '$log', '$http', '$q'];
})();
(function() {
    'use strict';

    angular
        .module('ceo')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $state, $stateParams, loadingService, $timeout, storageService) {

        /**
         * @ngdoc method
         * @name app.object:run#$stateChangeStart
         * @methodOf app.object:run
         * @description
         * Aqui vamos a interceptar el comienzo del cambio de vista. Primero vamos
         * a activar un loader porque hasta que cambie de vista lo que esta haciendo
         * son los resolve. Al activar el loader, lo que hacemos es que en el caso
         * de que el resolve le cueste un poco que no de la sensacion de que algo ha
         * fallado.
         *
         * Por otro lado controlamos la seguridad. Primero miramos si el usuario esta
         * autenticado. La informacion de si esta autenticado esta el loginSrv pero
         * puede darse el caso de que le haya dado a F5 y haya reiniciado los js, en ese
         * caso estara autenticado pero no tendra la informacion. Para eso vamos al
         * localStorage para recuperarla. En el caso de que este autenticado le dejamos
         * seguir al estado al que iba, sino lo reenviamos al
         **/
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            console.log('STATE CHANGE RESOLVING: ', toState.name, fromState.name);
            // este servicio se usa para hacer las transiciones de las paginas. Cuando pasa por aqui
            // se activa la animacion. En este momento hasta que se lanza el evento $stateChangeSuccess esta
            // lanzando todos los resolves. Para hacer que dure como minimo un tiempo esta transicion ponemos
            // un timeout en todas las rutas
            loadingService.loader.loading = true;
            var lastTimestampTag = storageService.retrieve('lastTimestampTag');
            if (lastTimestampTag) {
                var lttDate = moment(lastTimestampTag);
                var nowDate = moment(Date.now());
                if (!lttDate.isSame(nowDate, 'day')) {
                    storageService.remove('path');
                    storageService.remove('catalog');
                    storageService.remove('currentSelection');
                    storageService.remove('currentStep');
                    storageService.remove('debug');
                    storageService.remove('lastStep');
                    storageService.remove('lastTimestampTag');
                    $state.go('main');
                    event.preventDefault();
                } else if (lttDate.isBefore(nowDate.subtract(10, 'minutes'))) {
                    storageService.remove('path');
                    storageService.remove('catalog');
                    storageService.remove('currentSelection');
                    storageService.remove('currentStep');
                    storageService.remove('debug');
                    storageService.remove('lastStep');
                    storageService.remove('lastTimestampTag');
                    $state.go('main');
                    event.preventDefault();
                }
            } else {
                storageService.remove('path');
                storageService.remove('catalog');
                storageService.remove('currentSelection');
                storageService.remove('currentStep');
                storageService.remove('debug');
                storageService.remove('lastStep');
                storageService.remove('lastTimestampTag');
                if (toState.name !== 'main') {
                    $state.go('main');
                    event.preventDefault();
                }
            }
        });

        /**
         * @ngdoc method
         * @name app.object:run#$stateChangeSuccess
         * @methodOf app.object:run
         * @description
         * Aqui vamos a interceptar el caso de que el cambio de vista se ha
         * realizado correctamente y lo que hecemos es cancelar la animacion
         * de carga
         **/
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            console.log('STATE CHANGE RESOLVED SUCCESFULL: ', fromState.name, toState.name);

            // Si ha llegado hasta aqui es porque ha conseguido hacer los resolves sin problemas. Ahora podemos
            // hacer que se pare la animacion de la transicion de la pagina y pase al controlador para que haga
            // sus operaciones o mantener la animacion hasta que en el controlador se le diga que pare
            if (toState.data && toState.data.endLoading === false) {
                // si en el router ponemos en data endLoading = false no parara la animacion de la transicion de
                // pagina hasta que en el controlador se cambie a false loadingserviceSrv.loader.loading
            } else {
                // paramos la animacion
                loadingService.loader.loading = false;
            }
            console.log('Entrada en estado ', toState, ' correcta');
        });

        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
            console.log('STATE CHANGE FAILED TO RESOLVE: ', fromState.name, toState.name, error);
            // window.location = '404.html';
        });

        $rootScope.$on('$stateNotFound',
            function(event, unfoundState, fromState, fromParams) {
                console.log('Estado ', unfoundState, ' no encontrado');
            });
        $log.debug('runBlock end');
    }

})();
(function() {
    'use strict';

    angular
        .module('ceo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/main/main.template.html',
                controller: 'MainController',
                controllerAs: 'main',
                resolve: {
                    indice: ['mainService',
                        function(mSrv) {
                            return mSrv.getIndice();
                        }
                    ],
                    indiceList: ['mainService', 'indice',
                        function(mSrv, indice) {
                            return mSrv.getIndiceList();
                        }
                    ],
                    path: ['storageService',
                        function(sSrv) {
                            return sSrv.retrieve('path');
                        }
                    ],
                    colors: ['colorService', function(cSrv) {
                        return cSrv.getColors();
                    }]
                }
            }).
        state('main.evolution', {
            url: '/evolucio',
            views: {
                content: {
                    templateUrl: 'app/evolution/evolution.template.html',
                    controller: 'EvolutionController',
                    controllerAs: 'evolution'
                }
            },
            params: {
                catalog: null
            },
            resolve: {
                catalog: ['$stateParams', 'storageService',
                    function($stateParams, sSrv) {
                        var catalog = $stateParams.catalog;
                        if (!catalog) {
                            catalog = sSrv.retrieve('catalog');
                        } else {
                            sSrv.remove('currentSelection');
                            sSrv.save('catalog', catalog);
                        }
                        return catalog;
                    }
                ],
                filters: ['CatalogService', 'catalog',
                    function(cSrv, catalog) {
                        return cSrv.openCatalog(catalog);
                    }
                ],
                currentSelection: ['storageService',
                    function(sSrv) {
                        return sSrv.retrieve('currentSelection');
                    }
                ],
                timing: ['$timeout',
                    function($timeout) {
                        return $timeout(function() {}, 1300, false);
                    }
                ]
            }
        });

        $urlRouterProvider.otherwise('/main');
    }

})();
/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('ceo')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
    'use strict';

    angular
        .module('ceo')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig, $mdIconProvider, $mdThemingProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;
        $mdIconProvider.fontSet('fa', 'fontawesome');
    }

})();
angular.module("ceo").run(["$templateCache", function($templateCache) {$templateCache.put("app/evolution/evolution.template.html","<div layout=\"column\" layout-fill=\"\" id=\"evolution\" layout-align=\"center start\" ng-if=\"!evolution.loadingService.isLoading()\" flex=\"grow\"><div class=\"chart-filter w100\" layout=\"row\" layout-align=\"start center\" flex=\"grow\" ng-if=\"evolution.showFilter\"><div class=\"filter-part\" flex=\"30\"><div class=\"variable-filter\"><div class=\"p5\">Filtre</div><input type=\"hidden\" name=\"variableFilter\" id=\"sel_v_filter\" class=\"seleccion\" odecui-select2=\"\" datos=\"evolution.filter.variables\" selection=\"evolution.filter.selection.variable\" options=\"{width: \'100%; \',allowClear: false,placeholder:\'Seleccione un filtre\'}\" events=\"onVariableChanged\"></div></div><div class=\"filter-part\" ng-if=\"evolution.showItems\" flex=\"30\"><div class=\"item-filter\"><div class=\"p5\">Categoria del filtre</div><input type=\"hidden\" name=\"itemFilter\" id=\"sel_i_filter\" class=\"seleccion\" odecui-select2=\"\" datos=\"evolution.filter.items\" selection=\"evolution.filter.selection.item\" options=\"{width: \'100%\',allowClear: false,placeholder:\'Seleccione un element del filtre\'}\" events=\"onCategoryChanged\"></div></div><div class=\"filter-part\"><div class=\"export-options\"><div class=\"p5 text-center options-title\">Opcions<md-icon md-font-set=\"material-icons\" class=\"pl10\">settings</md-icon></div><div class=\"options-menu-container pl10\"><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Obrir menu d\'exportacions\" class=\"md-icon-button\" ng-click=\"evolution.openExportMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">file_download</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-href=\"./datos/{{evolution.catalog}}.xls\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">insert_drive_file</md-icon>Exportar dades en Excel</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'PDF\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a PDF</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'PNG\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a PNG</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'JPEG\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a JPEG</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"evolution.onChartPrint()\" md-prevent-menu-close=\"true\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">print</md-icon>Imprimir gràfic</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Obrir menu d\'opcions del gràfic\" class=\"md-icon-button\" ng-click=\"evolution.openOptionsMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">menu</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"evolution.showAllSeries()\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">done_all</md-icon>Mostrar tots</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.showNoneSeries()\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">filter_none</md-icon>Amagar tots</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-repeat=\"s in evolution.series\"><md-button aria-label=\"Canvia la visualització de la serie\" ng-click=\"evolution.changeSerieState(s)\" md-prevent-menu-close=\"\"><div ng-if=\"s.visible\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">check_box</md-icon>{{ s.name }}</div><div ng-if=\"!s.visible\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">check_box_outline_blank</md-icon>{{ s.name }}</div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div ng-if=\"evolution.showChart\" class=\"chart-container\" layout-fill=\"\"><div highchart=\"\" id=\"evolutionChart\" config=\"evolution.chart\" class=\"chart-wrapper\"></div></div><div ng-if=\"!evolution.showChart\" class=\"mt15 error-chart-container w100\" layout-fill=\"\" layout=\"column\" flex=\"grow\"><div class=\"error-chart-message w100\" layout=\"column\" layout-fill=\"\"><md-card class=\"p10\"><md-icon md-font-set=\"material-icons\">error</md-icon><div class=\"pt10 text-center\">No hi ha mostra disponible per a aquest gràfic</div></md-card></div></div></div>");
$templateCache.put("app/evolution/evolution.toast.template.html","<div layout=\"column\" layout-fill=\"\" id=\"evolution\" layout-align=\"center start\"><div class=\"open-filter-button\" ng-class=\"{\'panel-open\': evolution.showFilter, \'panel-closed\': !evolution.showFilter}\"><md-button aria-label=\"Obrir opcions de filtrat\" class=\"md-icon-button md-raised\" ng-click=\"evolution.showFilter = !evolution.showFilter\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">cast_connected</md-icon></md-button></div><div class=\"chart-filter w100\" layout=\"row\" layout-align=\"start center\" flex=\"grow\" ng-if=\"evolution.showFilter\"><div class=\"filter-part\" flex=\"30\"><div class=\"variable-filter\"><div class=\"p5\">Variable per graficar</div><input type=\"hidden\" name=\"variableFilter\" id=\"sel_v_filter\" class=\"seleccion\" odecui-select2=\"\" datos=\"evolution.filter.variables\" selection=\"evolution.filter.selection.variable\" options=\"{width: \'100%; \',allowClear: false,placeholder:\'Selecciona una variable per filtrar\'}\" events=\"onVariableChanged\"></div></div><div class=\"filter-part\" ng-if=\"evolution.showItems\" flex=\"30\"><div class=\"item-filter\"><div class=\"p5\">Categoria de la variable</div><input type=\"hidden\" name=\"itemFilter\" id=\"sel_i_filter\" class=\"seleccion\" odecui-select2=\"\" datos=\"evolution.filter.items\" selection=\"evolution.filter.selection.item\" options=\"{width: \'100%\',allowClear: false,placeholder:\'Selecciona un element de la variable per filtrar\'}\" events=\"onCategoryChanged\"></div></div><div class=\"filter-part\"><div class=\"export-options\"><div class=\"p5 text-center options-title\">Opcions<md-icon md-font-set=\"material-icons\" class=\"pl10\">settings</md-icon></div><div class=\"options-menu-container pl10\"><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Obrir menu d\'exportacions\" class=\"md-icon-button\" ng-click=\"evolution.openExportMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">file_download</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-href=\"../../datos/{{evolution.catalog}}.xls\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">insert_drive_file</md-icon>Exportar dades en Excel</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'PDF\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a PDF</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'PNG\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a PNG</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.onChartExport(\'JPEG\')\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">image</md-icon>Exportar gràfic a JPEG</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"evolution.onChartPrint()\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">print</md-icon>Imprimir gràfic</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Obrir menu d\'opcions del gràfic\" class=\"md-icon-button\" ng-click=\"evolution.openExportMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">menu</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"evolution.showAllSeries()\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">done_all</md-icon>Mostrar tots</md-button></md-menu-item><md-menu-item><md-button ng-click=\"evolution.showNoneSeries()\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">filter_none</md-icon>Amagar tots</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-repeat=\"s in evolution.series\"><md-button ng-click=\"evolution.changeSerieState(s)\"><div ng-if=\"s.visible\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">check_box</md-icon>{{ s.name }}</div><div ng-if=\"!s.visible\"><md-icon md-font-set=\"material-icons\" md-menu-align-target=\"\">check_box_outline_blank</md-icon>{{ s.name }}</div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div ng-if=\"evolution.showChart\" class=\"mt15 chart-container\"><div highchart=\"\" id=\"evolutionChart\" config=\"evolution.chart\" class=\"chart-wrapper\"></div></div><div ng-if=\"!evolution.showChart\" class=\"mt15 error-chart-container w100\" layout=\"column\" flex=\"grow\"><div class=\"error-chart-message\">No hi ha mostra disponible per a aquest gràfic</div></div></div>");
$templateCache.put("app/filtro/filtro.template.html","<div class=\"filtro-view\"><div layout=\"row\" layout-align=\"start center\"><div class=\"filtro-button\" ng-click=\"filter.open=!filter.open\"><div class=\"filtro-panel\" flex=\"grow\"><div><i class=\"fa fa-filter\"></i></div></div></div><div layout=\"column\" layout-align=\"space-around start\" class=\"filter-description\" flex=\"grow\"><p><span class=\"filter-title\"><i class=\"fa fa-map-marker\"></i> Venue :</span><span>{{ filter.vs.text }}</span> <i class=\"fa fa-arrows-h icon-versus\" ng-show=\"filter.isComparing()\"></i> <span ng-show=\"filter.isComparing()\">{{ filter.vt.text }}</span></p><p><span class=\"filter-title\"><i class=\"fa fa-th-list\"></i> Breakdown :</span><span>{{filter.textBreakdowns}}</span></p><p><span class=\"filter-title\"><i class=\"fa fa-calendar-o\"></i> Period:</span><span>{{ filter.periodText }}</span></p></div></div><div class=\"filtro-nav\" ng-show=\"filter.open\" ng-class=\"{\'open\': filter.open}\"><div class=\"item-net\" ng-class=\"{\'closed-filter\':filter.active != \'network\'}\"><div class=\"item-header\" ng-click=\"filter.active = \'network\'\" role=\"button\"><p><i class=\"fa fa-map-marker mr10\"></i>VENUE</p></div><div class=\"item-body\"><div class=\"item-filter\"><p>Select venue</p><input type=\"hidden\" name=\"compare_src\" id=\"sel_venue_ppral\" class=\"seleccion\" odecui-select2=\"\" datos=\"filter.venues\" selection=\"filter.comparison.source\" options=\"{width: \'100%\',allowClear: true,placeholder:\'Select venue\'}\"></div><div class=\"item-filter\"><p>to compare with</p><input type=\"hidden\" name=\"compare_tgt\" id=\"sel_venue_ppral\" class=\"seleccion\" odecui-select2=\"\" datos=\"filter.venues\" selection=\"filter.comparison.target\" options=\"{width: \'100%\',allowClear: true,placeholder:\'Select venue to compare with\'}\"></div></div></div><div class=\"item-net\" ng-class=\"{\'closed-filter\':filter.active != \'desglose\'}\"><div class=\"item-header\" ng-click=\"filter.active = \'desglose\'\"><p><i class=\"fa fa-th-list mr10\"></i>Breakdowns</p></div><div class=\"item-body\"><div class=\"item-filter\" ng-repeat=\"bd in filter.breakdowns\"><p><input type=\"radio\" ng-model=\"filter.vbdselected\" ng-value=\"bd.id\" ng-change=\"filter.BDSelected(bd.id)\"> {{ bd.text }}</p><div ng-class=\"{\'showMe\': filter.vbdselected === bd.id}\" class=\"collapsable\"><input type=\"hidden\" name=\"{{ bd.id }}\" class=\"seleccion\" odecui-select2=\"\" datos=\"bd.options\" selection=\"filter.breakdown[bd.id]\" options=\"{width: \'100%\',allowClear: true,placeholder:\'Select value ...\'}\"></div></div></div></div><div class=\"item-net\" ng-class=\"{\'closed-filter\':filter.active != \'periodo\'}\"><div class=\"item-header\" ng-click=\"filter.active = \'periodo\'\"><p><i class=\"fa fa-calendar-o mr10\"></i>TIME PERIOD</p></div><div class=\"item-body\" layout=\"column\" layout-align=\"center start\"><div class=\"pl10 w100\" layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised md-primary calendar-field\" ng-click=\"filter.ChangeCollapsedStateFrom()\">From : {{ filter.period_aux.from| amDateFormat:\'MM / DD / YYYY\' }}<i class=\"fa fa-calendar ml10\"></i></md-button><div class=\"calendarFrom\" ng-hide=\"filter.dtCollapsedFrom\"><div date-picker=\"filter.period_aux.from\" view=\"date\" date-change=\"filter.changeDate\" watch-direct-changes=\"true\" min-view=\"date\"></div></div><md-button class=\"md-raised md-primary calendar-field\" ng-click=\"filter.ChangeCollapsedStateTo()\">To : {{ filter.period_aux.to | amDateFormat:\'MM / DD / YYYY\' }}<i class=\"fa fa-calendar ml10\"></i></md-button><div class=\"calendarTo\" ng-hide=\"filter.dtCollapsedTo\"><div date-picker=\"filter.period_aux.to\" view=\"date\" date-change=\"filter.changeDate\" watch-direct-changes=\"true\" min-view=\"date\"></div></div><hr><md-button class=\"md-warn md-raised md-hue-2\" ng-click=\"filter.clearPeriod()\">Clear filter period</md-button></div><hr></div></div><div class=\"filtro-apply text-center\"><button type=\"button\" class=\"btn btn-filtro-apply\" ng-click=\"filter.aplicar()\">Aplicar</button></div></div></div>");
$templateCache.put("app/main/main.template.html","<div layout=\"column\" layout-fill=\"\" id=\"main\" layout-align=\"start start\"><section class=\"w100\"><div layout=\"row\" layout-align=\"start start\" class=\"breadcrumb p10\"><div ng-repeat=\"p in main.path\" class=\"path-step\" ng-if=\"!main.showSearchPanel\"><span ng-click=\"main.onPathClick(p)\" ng-class=\"{\'last-step\': $last}\" class=\"ml5 step\"><i class=\"mr5 fa\" ng-class=\"{\'fa-home\': $first}\"></i>{{ p.text }}</span><span ng-if=\"!$last\" class=\"ml5 truncate\"><md-icon md-font-set=\"material-icons\">arrow_forward</md-icon></span><md-tooltip>{{ p.text }}</md-tooltip></div><div class=\"search-title\" ng-if=\"main.showSearchPanel\">Cerca</div><div class=\"search-btn\" ng-click=\"main.onSearchPanelButtonClick()\" event-focus=\"click\" event-focus-id=\"sBtn\"><md-icon md-font-set=\"material-icons\">search</md-icon><md-tooltip class=\"large\">Cercar</md-tooltip></div></div><div ng-if=\"main.showPathPanel\" class=\"step-ways-container\"><div class=\"options-list-container\"><div class=\"options-list mb5\"><div ng-repeat=\"s in main.currentStep.sections\" ng-click=\"main.onPathClick(s)\" class=\"option\"><span><i class=\"fa fa-folder-open mr10\"></i>{{ s.text }}</span></div><div ng-repeat=\"i in main.currentStep.items\" ng-click=\"main.onPathClick(i)\" class=\"option\"><span><i class=\"fa fa-file-text-o mr10\"></i>{{ i.text }}</span></div></div><md-button ng-if=\"main.currentStep.items || main.currentStep.sections\" class=\"mt10 md-raised md-primary\" ng-click=\"main.showPathPanel = false\"><i class=\"fa fa-close mr5\"></i>Tancar</md-button></div></div><div ng-if=\"main.showSearchPanel\" class=\"step-ways-container\"><div class=\"options-list-container\"><div class=\"sarch-input-panel mb10\"><md-input-container class=\"pb15\"><label>Text a cercar</label> <input id=\"sBtn\" name=\"search-text\" ng-model=\"main.search.text\" ng-change=\"main.doSearch()\" ng-keyup=\"main.onSearchKeyUp($event)\" required=\"\" md-autofocus=\"main.showSearchPanel\"></md-input-container><div class=\"w100\" layout=\"row\" flex=\"grow\" layout-align=\"end center\" ng-if=\"!main.search.items || main.search.items.length === 0\"><md-button class=\"md-raised\" ng-click=\"main.showSearchPanel = false\">Tancar</md-button></div></div><div class=\"options-list mb5 search-container\" ng-if=\"main.search.items || main.search.items.length > 0\"><div ng-repeat=\"i in main.search.items\" ng-click=\"main.onPathClick(i)\" class=\"option\"><span>{{ i.text }}</span></div></div><md-button ng-if=\"main.search.items\" class=\"mt10 md-raised md-primary\" ng-click=\"main.showSearchPanel = false\"><i class=\"fa fa-close mr5\"></i>Tancar</md-button></div></div></section><section class=\"content w100 mt10\"><section class=\"main-content\"><div ui-view=\"filter\"></div><div class=\"content-wrap\"><div class=\"wrapper\" ui-view=\"content\" ng-if=\"!main.loader.loading\"></div><div layout=\"row\" layout-fill=\"\" id=\"main-loader\" layout-align=\"center center\" ng-if=\"main.loader.loading\"><img class=\"loader-bar\" src=\"./assets/preloaders/285.gif\"></div></div></section></section><section class=\"footer\"></section></div>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=\"row\" layout-align=\"center center\"><md-button href=\"https://github.com/Swiip/generator-gulp-angular\">Gulp Angular</md-button><section flex=\"\" layout=\"row\" layout-align=\"left center\"><md-button href=\"#\" class=\"md-raised\">Home</md-button><md-button href=\"#\" class=\"md-raised\">About</md-button><md-button href=\"#\" class=\"md-raised\">Contact</md-button></section><md-button class=\"acme-navbar-text\">Application was created {{ vm.relativeDate }}.</md-button></md-toolbar>");}]);